import React from 'react';
import { Quote, Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  location: string;
  quote: string;
  imageInitials: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  quote,
  imageInitials
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-13">
      <div className="flex items-center mb-4" data-id="element-14">
        <div className="w-12 h-12 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-lg mr-4 shrink-0" data-id="element-15">
          {imageInitials}
        </div>
        <div data-id="element-16">
          <h3 className="font-bold text-gray-900" data-id="element-17">{name}</h3>
          <p className="text-sm text-gray-500" data-id="element-18">{role}</p>
          <p className="text-xs text-gray-400" data-id="element-19">{location}</p>
        </div>
      </div>

      <div className="flex mb-3" data-id="element-20">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-21" />)}
      </div>

      <div className="relative flex-grow" data-id="element-22">
        <Quote className="absolute -top-2 -left-2 w-6 h-6 text-blue-100 transform -scale-x-100" data-id="element-23" />
        <p className="text-gray-700 italic relative z-10 pl-4" data-id="element-24">"{quote}"</p>
      </div>
    </div>;
}